import React from 'react';
import { BrowserRouter, Route, Switch, } from 'react-router-dom';
import {BrowseHistory} from 'history'
import ScrollToTop from './ScrollToTop';
import Menu from './Menu/Menu';
import App from './App/App';
import ProductsRouter from './Products/ProductsRouter';
import AboutUs from './AboutUs/AboutUs'
import Create from './Products/Create/Create'
import Products from './Products/Products'
import StoreReceipt from './StoreReceipt/StoreReceipt'
import { DesignModeProvider } from './DesignModeContext';
import WelcomeModal from './WelcomeModal/WelcomeModal';
//import Footer from './Footer/Footer'

const Router = () => (
<DesignModeProvider>
  <BrowserRouter >
      <WelcomeModal />
      <ScrollToTop />
      <Switch>
        <Route exact path="/" component={App} />
        <Route path="/About-Us" component={AboutUs} />
        <Route exact path="/Products/Create" component={Create} />
        <Route exact path="/Products" component={Products} />
        <Route path="/Products" component={ProductsRouter} />
        <Route path="/storereceipt/:GUID" component={StoreReceipt} />
      </Switch>
    </BrowserRouter>
</DesignModeProvider>
);

export default Router;